import React from 'react';
import PropTypes from 'prop-types';

const ColorSwatch = ({ color }) => {
	return (
		<span
			className={`normalized-swatch normalized-swatch-${color.toLowerCase()} mr-3`}
		/>
	);
};

ColorSwatch.propTypes = {
	color: PropTypes.string.isRequired
};

export default ColorSwatch;
